import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { AuthService, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { Subject } from "rxjs";
import { SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { ReportInfo, StimulSoftReportComponent } from "../../stimul-soft-report/stimul-soft-report.component";
import { ReportKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class LocalSettingService implements OnInit, OnDestroy {
  public tabsservice: TabularService;
  protected ngUnsubscribe = new Subject<void>();
  constructor(public httpCommonService: HttpCommonService, public authService: AuthService, private translate: TranslateService) {}
  ngOnInit() {}
  print(saveReportFile: SaveReportFile, apiName: string, dataList: any[]) {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.print;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.pathPreFix = "FrontOffice";
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  printData(data: any) {
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.translate.instant("ClientApp.FrontOffice.LocalSetting.CustomerPrint");
    saveReportFile.FileName = data.PrintTemplateName;
    saveReportFile.SystemKindName = "SALE";
    saveReportFile.CategoryName = "Invoice";
    this.print(saveReportFile, "Invoice", [data]);

    //this.httpCommonService.create("LocalSetting/GetPrintPolicy", model)
    //  .pipe(takeUntil(this.ngUnsubscribe))
    //  .subscribe((x: PrintPolicy) => {
    //    if (x) {
    //      let saveReportFile: SaveReportFile = <SaveReportFile>{};
    //      saveReportFile.ReportTitle = "چاپ مشتری";
    //      saveReportFile.FileName = x.PrintTemplateName;
    //      saveReportFile.SystemKindName = "SALE";
    //      saveReportFile.CategoryName = "Invoice";
    //    }
    //  }, error => { });
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
}
